export class RegionMiniEntity {
  id?: number
  name?: string | null
  countryName?: string
  location?: {
    lat?: number
    lng?: number
  }
}
